import { FLOOR_KEY } from 'common/consts/local-storage-key.const';
import { storageManager } from 'common/helpers/local-storege-manager.helper';
import { getLocalStorageAvailable } from 'common/helpers/get-local-storage-available.helper';

export const clearRoomsStorage = () => {
  const isLocalStorageAvailable = getLocalStorageAvailable();
  if (isLocalStorageAvailable) {
    const roomsFromStorage = storageManager.getItem(FLOOR_KEY);
    if (roomsFromStorage !== null) {
      storageManager.removeItem(FLOOR_KEY);
    }
  }
};
